
import * as Yup from "yup"

Yup.setLocale( {
  mixed: {
    default: "Campo inválido",
    required: "Campo obrigatório",
    notOneOf: "Valores inválidos: ${values}",
    oneOf: "Valores aceites: ${values}",
  },
  string: {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: "${path} must match the following: \"${regex}\"",
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string",
  },
  number: {
    min: "Valor tem que ser maior ou igual a ${min}",
    max: "Valor tem que ser menor ou igual a ${max}",
    lessThan: "Valor tem que ser menor que ${less}",
    moreThan: "Valor tem que ser maior que ${more}",
    notEqual: "Valor nao pode ser igual a ${notEqual}",
    positive: "Valor tem que ser um número positivo",
    negative: "Valor tem que ser um número negativo",
    integer: "Valor tem que ser um número inteiro",
  },
  date: {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}",
  },
  boolean: {},
  object: {
    noUnknown: "${path} field cannot have keys not specified in the object shape",
  },
  array: {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
  },
} )

export default Yup



// WEBPACK FOOTER //
// ./src/lib/Yup.jsx